// @flow
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import * as css from './Modal.module.css';
import classNames from 'classnames/bind';
import ReactMarkdown from 'react-markdown';
import T2AppleWatch from '../../views/Confirm/Tele2AppleWatch';
import SamsungWatchSvg from '../../views/Confirm/SamsungWatchSvg';
import { isAppleDevice } from '../../helpers/customerTypeHelpers';
import { ModalTypes } from '../../Constants';
import RenderTerms from './RenderTerms';

type PropsType = {
  handleAccept: () => void,
  handleClose: () => void,
  content: Object,
  type: string,
  isComviq?: boolean,
};

const Modal = ({ handleAccept, handleClose, content, type, isComviq = false }: PropsType) => {
  const cx = classNames.bind(css);
  const modalClasses = cx({
    [type]: true,
    modal: true,
  });
  const comvicCss = isComviq ? css.comviq : '';
  const isPromotion = type === ModalTypes.PROMOTION;
  return (
    <div className={modalClasses}>
      <div className={`${css.container} ${comvicCss}`}>
        <div className={css.header}>{handleClose && <Icon onClick={handleClose} />}</div>
        <p className={css.title}>{content.title}</p>
        {isPromotion && (
          <>
            {isAppleDevice() ? <T2AppleWatch /> : <SamsungWatchSvg />}
            <div className={css.content}>{content.text && <ReactMarkdown source={content.text} />}</div>
          </>
        )}
        {!isPromotion && <RenderTerms terms={content} isComviq={isComviq} />}
        <div className={css.footer}>
          {handleAccept && (
            <Button color="blue" primary fluid onClick={handleAccept}>
              {content.accept}
            </Button>
          )}

          {handleClose && (
            <Button color="blue" primary fluid onClick={handleClose}>
              {content.close}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Modal);
